import { useCallback } from 'react';
import { useWindowEventListener } from './use-window-event-listener';
/**
 * Add a resize event listener to the window object for the lifecycle of a component. Cleans up when a value in deps
 * list changes or the component unmounts.
 */ export const useResizeEventListener = (callback, deps)=>{
    const handleWindowResized = useCallback(()=>{
        callback({
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        });
    }, [
        callback
    ]);
    useWindowEventListener(handleWindowResized, 'resize', deps);
};
